import EntityNotificationsAddEditForm from './EntityNotificationsAddEditForm';

export default EntityNotificationsAddEditForm;
